export default {
  years: "Jahre",
  countries: "Länder",
  leadership: "Führung",
  quality: "Qualität",
  solutions: "Lösungen",
  facilities: "Einrichtungen",
  approvals: "Zulassungen",
  customers: "Kunden",
  operations: "Operationen",
  focused: "Fokussiert",
  vision: "Vision",
};

